import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class Person extends BaseAdapter {
  namespace = 'people/v4';
  modelNamePlural = 'people';
}
